import { apiService } from './apiService';

export const trafficFineService = {
  async getFines() {
    return apiService.get('/traffic-fines');
  },
  async createFine(data: any) {
    return apiService.post('/traffic-fines', data);
  },
  async updateFine(id: string | number, data: any) {
    return apiService.put(`/traffic-fines/${id}`, data);
  },
  async getInstallments(id: string | number) {
    return apiService.get(`/traffic-fines/${id}/installments`);
  },
  async resolveDriverByAsset(params: { vehicleKind: 'tractor' | 'trailer'; vehicleId?: string; trailerId?: string; fineDate?: string }) {
    const queryParams = new URLSearchParams();
    queryParams.append('vehicleKind', params.vehicleKind);
    if (params.vehicleId) queryParams.append('vehicleId', params.vehicleId);
    if (params.trailerId) queryParams.append('trailerId', params.trailerId);
    if (params.fineDate) queryParams.append('fineDate', params.fineDate);
    return apiService.get(`/traffic-fines/resolve-driver?${queryParams.toString()}`);
  },
  async createInstallments(id: string | number, data: { installmentCount?: number; installmentAmount?: number; firstInstallmentDate: string }) {
    return apiService.post(`/traffic-fines/${id}/installments`, data);
  },
  async payInstallment(installmentId: string | number) {
    return apiService.put(`/traffic-fines/installments/${installmentId}/pay`);
  },
  async bulkUpdateProcessStatus(ids: Array<string | number>, processStatus: string) {
    return apiService.put('/traffic-fines/bulk-process-status', { ids, processStatus });
  },
  async deleteFine(id: string | number) {
    return apiService.delete(`/traffic-fines/${id}`);
  },
};
